import { useTranslation } from 'react-i18next'

import { Button, message, Modal } from '@/components'

/**
 * One-time api_key display (after route creation or credential rotation) — the key is
 * never retrievable again (no masked_key, no re-query; backend security policy, final).
 */
export function ApiKeyModal({ apiKey, onClose }: { apiKey: string; onClose: () => void }) {
  const { t } = useTranslation('modelRoute')

  const handleCopy = () => {
    navigator.clipboard.writeText(apiKey)
    message.success(t('apiKeyModal.copied', 'API key copied'))
  }

  return (
    <Modal className="w-[640px]" open={true} onClose={onClose}>
      <Modal.Header>{t('apiKeyModal.title', 'Route API Key')}</Modal.Header>
      <Modal.Body>
        <div className="border border-neutral-200 rounded-lg px-4 py-3 min-h-[56px] break-all t-sb text-primary">
          {apiKey}
        </div>
        <p className="mt-2 t-sm text-secondary">
          {t(
            'apiKeyModal.warning',
            'This API key is shown only once. Copy and store it now — it cannot be retrieved later.',
          )}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button type="outline" className="min-w-[88px]" onClick={onClose}>
          {t('apiKeyModal.done', 'Done')}
        </Button>
        <Button type="secondary" className="min-w-[88px]" onClick={handleCopy}>
          {t('apiKeyModal.copy', 'Copy')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
